"use client";

import { motion } from "framer-motion";
import { ReactNode } from "react";

interface FadeInProps {
  children: ReactNode;
  delay?: number;
  direction?: "up" | "down" | "left" | "right" | "none";
  fullWidth?: boolean;
  className?: string;
  margin?: string;
}

export default function FadeIn({
  children,
  delay = 0,
  direction = "up",
  fullWidth = false,
  className = "",
  margin = "0px",
}: FadeInProps) {
  let initial: any = { opacity: 0 };
  if (direction === "up") initial.y = 40;
  if (direction === "down") initial.y = -40;
  if (direction === "left") initial.x = 40;
  if (direction === "right") initial.x = -40;

  return (
    <motion.div
      initial={initial}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once: true, margin: margin }}
      transition={{ duration: 0.6, delay, ease: "easeOut" }}
      className={`${fullWidth ? "w-full" : ""} ${className}`}
    >
      {children}
    </motion.div>
  );
}
